import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            影迷热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自真实影迷的使用体验与真诚反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <div className="font-semibold text-foreground-900 text-sm">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>

              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < comment.rating
                        ? 'ri-star-fill text-primary-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                {comment.content}
              </p>

              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {comment.liked}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}